import React, { FC, memo } from 'react';
import { handleImgError } from '@src/utils';
import { FALLBACK_IMAGE, IMAGE_STORAGE_URL } from '@src/utils/constants';
import { StatusWrapper } from '@component/StatusWrapper/StatusWrapper';

interface IAvatar {
  userImage: string;
  userStatus?: 'Online' | 'Offline' | 'Away';
}

const Avatar: FC<IAvatar> = ({ userImage, userStatus }) => {
  return (
    <div data-test-id="c-avatar" className="avatar-container">
      <StatusWrapper size={10} statusColor={userStatus ?? 'Offline'}>
        <div className="paper" data-test-id="avatar-paper">
          <img
            data-test-id="avatar-img"
            alt="avatar image"
            src={
              userImage ? `${IMAGE_STORAGE_URL}/${userImage}` : FALLBACK_IMAGE
            }
            onError={handleImgError}
          />
        </div>
      </StatusWrapper>
    </div>
  );
};

const areEqual = (prevProps, nextProps) => {
  return (
    prevProps.userImage === nextProps.userImage &&
    prevProps.userStatus === nextProps.userStatus
  );
};

export default memo(Avatar, areEqual);
